import l10n from "diy/util/l10n";

import ActionSettingsIcon from "material-ui/svg-icons/action/settings";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.MAINTENANCE_MODE,

    testId: "maintenance-mode",
    trackingId: "MaintenanceModeNotification",

    title: l10n("toolbar.maintenance.offline.notification.title"),
    content: l10n("toolbar.maintenance.offline.notification.description"),
    icon: ActionSettingsIcon,

    mainAction: {
        testId: "open-settings",
        label: l10n("toolbar.maintenance.link"),
        onClick: () => {
            diy.editor.deeplinking.requestPath([
                {label: "siteadmin", params: "settings"},
                {label: "SAC.Settings", params: "website-staging"}
            ]);
        }
    },

    cardOptions: {
        closable: false
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/MaintenanceMode.ts
 **/